import { GridRowSelectionMixin } from "@serenity-is/corelib";
import { HeaderFilterType } from "../GridMixins/HeaderFiltersPlugin";
import type { Column } from "@serenity-is/sleekgrid";

const orgCreateSelectColumn = GridRowSelectionMixin.createSelectColumn;
GridRowSelectionMixin.createSelectColumn = function (getMixin: () => GridRowSelectionMixin): Column {
    const col = orgCreateSelectColumn.call(this, function () {
        const mixin = getMixin && getMixin();
        mixin && mixin["grid"] && mixin["grid"].getGrid() && mixin["grid"].getGrid().onHeaderClick.subscribe(() => {
            setTimeout(mixin.updateSelectAll.bind(mixin), 0);
        });
        return mixin;
    }) as Column;
    col.width = 48;
    col.maxWidth = 48;
    col.minWidth = 48;
    col.headerFilterType = HeaderFilterType.disabled;
    col.autoSize = false;
    return col;
};
